var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fab-preview" }, [
    _c("span", { staticClass: "title" }, [
      _vm._v(_vm._s(_vm.$t("fastWizard.preview"))),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c(
        "div",
        { staticClass: "fab-items", class: { iconMode: _vm.fabIconActive } },
        _vm._l(_vm.fabs, function (fab, i) {
          var _obj
          return _c(
            "div",
            {
              key: fab.type,
              staticClass: "fab-item-preview",
              class:
                ((_obj = {}),
                (_obj[_vm.metas[fab.type].colorClass] = true),
                (_obj.disabled = !_vm.fabs[i].enable || !_vm.isFabsActive),
                (_obj.iconMode = !_vm.fabIconActive),
                _obj),
              model: {
                value: _vm.fabs[i],
                callback: function ($$v) {
                  _vm.$set(_vm.fabs, i, $$v)
                },
                expression: "fabs[i]",
              },
            },
            [
              _c("div", { staticClass: "fab-icon" }, [
                _c("img", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: true,
                      expression: "true",
                    },
                  ],
                  staticClass: "fab-icon",
                  attrs: {
                    src: "/static/img/fabImages/" + fab.type + "Icon.svg",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.metas[fab.type].title) +
                    "\n                "
                ),
              ]),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "bubble-preview-wrapper" },
        [_c("BubblePreview", { attrs: { width: "50px", height: "50px" } })],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }